package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class HomeworkListResponse(
    val count: Int,
    val items: List<HomeworkResponse>,
    val counters: HomeworkCounters,
)

@Serializable
data class HomeworkCounters(
    val total: Int? = null,
    val open: Int? = null,
    val closed: Int? = null,
    val overdue: Int? = null
)

@Serializable
data class TeacherHomeworkStatisticsResponse(
    @SerialName("teacher_id") val teacherId: String? = null,
    @SerialName("teacher_name") val teacherName: String? = null,
    val counters: TeacherHomeworkStatisticsCounters? = null
)

@Serializable
data class TeacherHomeworkStatisticsCounters(
    val total: Int? = null,
    @SerialName("assigned_by_me") val assignedByMe: Int? = null,
    val open: Int? = null,
    val closed: Int? = null,
    val overdue: Int? = null
)

@Serializable
data class HomeworkResponse(
    val id: String? = null,
    @SerialName("homework_id") val homeworkId: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null,
    @SerialName("subject_id") val subjectId: String? = null,
    @SerialName("subject_name") val subjectName: String? = null,
    val title: String? = null,
    val description: String? = null,
    @SerialName("due_date") val dueDate: String? = null,
    val status: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    @SerialName("notify_parents") val notifyParents: Boolean? = null,
    @SerialName("created_by_id") val createdById: String? = null,
    @SerialName("created_by_name") val createdByName: String? = null,
    @SerialName("assigned_by_teacher_id") val assignedByTeacherId: String? = null,
    @SerialName("assigned_by_teacher_name") val assignedByTeacherName: String? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String> = emptyList(),
    @SerialName("attachment_file_urls") val attachmentFileUrls: List<String> = emptyList(),
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null
)
